module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "退还确认",
      "visible": _vm.dialogVisible,
      "size": "small",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售下单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售下单时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderTime))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理商"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.AgentCode) + " " + _vm._s(_vm.OrderData.AgentName) + " " + _vm._s(_vm.OrderData.AgentAddress) + " " + _vm._s(_vm.OrderData.AgentTel))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "业务员"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.SaleEmployeeName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "换货状态"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.ReturnStatusName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderRemark))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "回寄快递信息"
    }
  }, [(_vm.OrderData.RetrunLogisticsName != '') ? _c('span', [_vm._v("回寄物流公司：" + _vm._s(_vm.OrderData.RetrunLogisticsName))]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.OrderData.RetrunLogisticsCode != '') ? _c('span', [_vm._v("回寄物流单号：" + _vm._s(_vm.OrderData.RetrunLogisticsCode))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    staticClass: "w100",
    attrs: {
      "label": "换货情况"
    }
  }, [_c('el-table', {
    staticStyle: {
      "margin-left": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "data": this.changeProductList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "退还资源包",
      "prop": "ReturnPro"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实际有效退还资源包",
      "width": "400px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.ReturnProName) + "\n                            "), _c('el-button', {
          staticStyle: {
            "margin-left": "5px"
          },
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.getConfig(scope.row)
            }
          }
        }, [_vm._v("选择")]), _vm._v(" "), _c('el-input-number', {
          staticStyle: {
            "margin-left": "5px"
          },
          attrs: {
            "size": "small",
            "min": 0
          },
          on: {
            "change": _vm.handleChange
          },
          model: {
            value: (_vm.num2[scope.$index]),
            callback: function($$v) {
              _vm.$set(_vm.num2, scope.$index, $$v)
            },
            expression: "num2[scope.$index]"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "需换资源包",
      "prop": "ChangePro"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.addTableCell
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "换货图片"
    }
  }, [_c('div', {
    attrs: {
      "id": "container-1"
    }
  }, [_vm._l((_vm.changePic), function(item) {
    return _c('div', {
      attrs: {
        "id": "ImgPrev"
      }
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image",
      attrs: {
        "id": "myProPic",
        "src": item.Url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-wrap"
    }, [_c('span', {
      staticClass: "entry-title"
    }, [_c('span', {
      staticClass: "featured-image"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.viewPicture(item.Url, _vm.changePic)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticStyle: {
        "width": "10px",
        "padding": "6px"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delPicture(item.Url, _vm.changePic)
        }
      }
    })])])])])])
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "80px",
      "height": "80px",
      "float": "left"
    },
    attrs: {
      "icon": "plus",
      "id": "upload-btn-1"
    }
  })], 2)])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "换货备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.confirmFormData.ReturnRemark),
      callback: function($$v) {
        _vm.$set(_vm.confirmFormData, "ReturnRemark", $$v)
      },
      expression: "confirmFormData.ReturnRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.dialogClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "可选资源包列表",
      "visible": _vm.dialogTabsVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTabsVisible = $event
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.returnConfigList), function(item, index) {
    return _c('el-tab-pane', {
      attrs: {
        "name": item.Id + ''
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(item.Name))]), _vm._v(" "), _c('ul', {
      staticClass: "prosList"
    }, _vm._l((item.List), function(list, index) {
      return _c('li', {
        class: {
          active: list.active
        },
        on: {
          "click": function($event) {
            _vm.chooseList(index, list, item.List)
          }
        }
      }, [_vm._v(" " + _vm._s(list.ProName) + " ")])
    }))])
  })), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogTabsVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.enSure
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d853bfa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/Exchange/components/returnOrderConfirm/index.vue
// module id = 1518
// module chunks = 1